<template>
	<div class="text-center">
	    <v-menu  :close-on-content-click="false" >
	      	<template v-slot:activator="{ on: menu, attrs }">
	        	<v-tooltip bottom>
	         		<template v-slot:activator="{ on: tooltip }">          
			            <v-btn
			              	dark 
			            	:x-small="isXSmall"
			            	:small="isSmall"
			            	:icon="isIcon"
			              	:color="colorField || 'transparent'"
			              	v-bind="attrs"
			              	v-on="{ ...tooltip, ...menu }"
			              	:fab="isFab" 
			              	:block="isBlock"	              	
			            >
		         			<v-badge
						    	left						    							    	
						    	bottom
						        overlap
						        bordered
						        color="green"						        
						        :content="renderSelecteds.length"
						        offset-x="5"
						        offset-y="18"					
						        :value="inputField[keyField].length > 0"							        
						    >
	              				<v-icon x-smal>mdi-video-box</v-icon>
    						</v-badge>	              			
	              			<v-input  height="2" v-show="isLabel" :messages="renderSelecteds">
	              				<span  style="font-size: 10px"> {{ $ml.get('devices')}} </span>
					        </v-input>	              			
	            		</v-btn>
	          		</template>
	          		<span>{{$ml.get("devices") }} : {{renderSelecteds}}</span>
	        	</v-tooltip>
	      	</template>
	      	<v-list dense>	      		
	      		<v-list-item  @click="selectAll()">	      			
		          	<v-list-item-title>{{ $ml.get('all') }}</v-list-item-title>	      		
		        </v-list-item>		    	
	      		<v-list-item-group
			        :multiple="isMultiple"
			        v-model="inputField[keyField]"
			        color="primary"
			    >
		        	<v-list-item
			          	v-for="(item, index) in renderList"
			          	:key="index"
			          	:value="valueField ? item[valueField] : item"
		        	>
		          		<v-list-item-title>{{ item.name }}</v-list-item-title>
		        	</v-list-item>
	        	</v-list-item-group>
	      	</v-list>
	    </v-menu>
  	</div>

</template>

<script type="text/javascript">
	export default{
		name : "MenuDevice",
		props : ["inputField", "keyField", "isLabel", "isXSmall", "isSmall", "isFab", "isIcon", "colorField", "isMultiple", "isBlock", "isReturnObject", "valueField"],
		data : ()=>({
			loading:false,
			menu:false,			

		}),
		computed:{
			renderList(){
				return this.$store.getters["Devices/list"]
			},
			renderSelecteds(){
				const listTemp = this.renderReturnInField();
				return listTemp.length ? listTemp.map(x=> x.name) :
					 [this.$ml.get("none_selected")] 
			}
		},		
		methods:{
			selectAll(){
				// this.$nextTick(() => {					
					if (this.inputField[this.keyField].length == this.renderList.length) {
						this.inputField[this.keyField]=[];
					}else{
						this.inputField[this.keyField]=this.renderList.map(x=> x.deviceId);						
					}
				// })
			},
			renderReturnInField(){						
				const listTemp=this.valueField && this.inputField[this.keyField].length ? this.renderList.filter(x=> this.inputField[this.keyField].includes(x.deviceId)) : 
						this.inputField[this.keyField];
				if(this.isReturnObject){
					this.$emit("returnDevices", listTemp)					
				}				
				return listTemp;
			},
		}
	}
</script>